function enableTooltip() {
	if (App.debug) {
		console.info('init: tooltip');
	}

	let tooltipTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="tooltip"]'));
	tooltipTriggerList.map(function (tooltipTriggerEl) {
		return new bootstrap.Tooltip(tooltipTriggerEl, {
			trigger: 'hover'
		})
	})
}

export default enableTooltip;
